<template>
  <v-app>
    <v-main class="mb-16">
      <v-btn
        fab
        @click.prevent="openHelpMail"
        size="small"
        color="primary"
        class="v-btn--floating-help-button"
        fixed
        bottom
        left
      >
        <v-icon>fa fa-question</v-icon>
      </v-btn>
      <Header
        class="mb-2"
        :backButton="backButton"
        :backFunction="backFunction"
        :title="pageTitle"
        :icon="icon"
        :routeTo="link"
        :routeToTitle="linkTitle"
        :visitButton="visitButton"
      />
      <div class="subcontainer">
        <slot></slot>
      </div>
    </v-main>
  </v-app>
</template>

<script>
import Header from "@/layouts/shared/Header";
import i18n from "@/services/i18n";
import {neoparentPatients as neoparentPatient, neoparentPatients} from "@/api";

export default {
  i18n: i18n,
  components: {
    Header
  },
  name: "neoparent-dashboard-layout",
  props: [],

  data() {
    return {
      path: window.location.pathname
    };
  },

  computed: {
    link() {
      switch (true) {
        case this.path === "/dashboard/dictionary":
          return "/dashboard/dictionary/tags";
        case this.path.includes("/dashboard"):
          return "/logout";
        default:
          return undefined;
      }
    },
    linkTitle() {
      switch (true) {
        case this.link === "/dashboard/dictionary/tags":
          return this.$t("button.tags");
        case this.link === "/logout":
          return this.$t("button.logout");
        default:
          return undefined;
      }
    },
    icon() {
      switch (true) {
        case this.path === "/dashboard/dictionary":
          return "tag-pink";
        case this.path.includes("/dashboard"):
          return "sign-out-pink";
        default:
          return undefined;
      }
    },
    pageTitle() {
      switch (true) {
        case this.path === "/dashboard":
          return `${this.$store.getters.user.nickName ? this.$store.getters.user.nickName : this.$store.getters.user.firstName + ' ' + this.$store.getters.user.lastName}`;
        case this.path === "/dashboard/statistics":
          return this.$t("dash.menu.statistics");
        case this.path === "/dashboard/profile":
          return this.$t("dash.menu.profile");
        case this.path === "/dashboard/messageconfiguration":
          return this.$t("dash.menu.messageConfiguration");
        case this.path === "/dashboard/dictionary/shadow":
          return this.$t("dash.shadowDictionary.title");
        case this.path === "/dashboard/dictionary/shadow-tags":
          return this.$t("dash.shadowTags.title");
        case this.path === "/dashboard/nurses":
          return this.$t("dash.nurse.title");
        case this.path === "/dashboard/nurse/create":
          return new URL(window.location).searchParams.get("nurseId")
            ? this.$t("dash.nurse.edit-title")
            : this.$t("dash.nurse.add-title");
        case this.path.includes("/dashboard/nurse") && !this.path.includes("/patient/create") && !this.path.includes("/patients") && !this.path.includes("visits"):
          return `${this.$store.getters.patient.firstName} ${this.$store.getters.patient.lastName}`;
         case this.path === "/dashboard/patient/create":
          return new URL(window.location).searchParams.get("patientId")
            ? this.$t("dash.patient.create.edit-title")
            : this.$t("dash.patient.create.add-title");
        case this.path === "/dashboard/hospital":
          return this.$t("dash.info.title");
        case this.path.includes("/dashboard/parent"):
          return `${this.$t("dash.patient.parent.title")}`;
        case this.path === "/dashboard/dictionary":
          return this.$t("dash.dictionary.title");
        case this.path === "/dashboard/dictionary/tags":
          return "Tags";
        case this.path === "/dashboard/dictionary/create":
          return this.$t('dash.dictionary.article.title');
        case this.path === "/dashboard/create/checklist":
          return this.$t('dash.checklist.titleFor') + ' ' + this.$store.getters.user.patient.firstName;
        case this.path.includes("/dashboard/nurse") && this.path.includes("/patients") && !this.path.includes("visits"):
          return this.$t('dash.info.bedOverview');
        default:
          return "NeoParent";
      }
    },
    backButton() {
      if (
        this.path === "/dashboard/statistics" ||
        this.path === "/dashboard/profile" ||
        this.path === "/dashboard/messageconfiguration" ||
        this.path === "/dashboard/dictionary/shadow" ||
        this.path === "/dashboard/dictionary/shadow-tags" ||
        (this.path.includes("/dashboard/nurse") && !this.path.includes("/dashboard/nurses") || this.$store.getters.user?.role === 'a') && this.path !== "/dashboard" ||
        this.path === "/dashboard/patients" ||
        this.path === "/dashboard/patient/create" ||
        this.path === "/dashboard/hospital" ||
        this.path.includes("/dashboard/parent") ||
        this.path === "/dashboard/dictionary" ||
        this.path === "/dashboard/dictionary/tags" ||
        this.path === "/dashboard/dictionary/create" ||
        this.path === "/dashboard/create/checklist"
      ) {
        if (window && window.history) {
          return true;
        }
        return false
      }
      return false;
    },
    backFunction() {
      switch (true) {
        case window.location.pathname === "/dashboard/nurses" ||
          window.location.pathname === "/dashboard/nurses":
          return function() {
            window.location.href = "/dashboard/nurses";
          };
        default:
          return null;
      }
    },
    visitButton() {
      if (
        this.path.includes("/dashboard/nurse") &&
        this.path.includes("/patients")
      ) {
        return `/dashboard/nurse/${this.$store.getters.nurse.id}/visits?view=all`;
      }
      return false;
    },
    plusFunction() {
      if (this.path == "/dashboard/dictionary/tags") {
        return "/";
      }
      return false;
    }
  },

  mounted() {
    this.$i18n.locale = this.$store.getters.user?.language ?? 'nl-be'
  },

  methods: {
    openHelpMail() {
      window.open("mailto:support@leapstation.eu", "_blank");
    }
  }
};
</script>

<style lang="scss">
.subcontainer {
  margin: 55px;
}

.v-btn--floating-help-button {
  margin-bottom: 35px;
}

@media (max-width: 1024px) {
  .subcontainer {
    margin: 52px 8px 20px;
  }

  .v-btn--floating-help-button {
    margin-bottom: 18px;
  }
}

@media (hover: none) and (pointer: coarse) {
  .subcontainer {
    margin: 52px 4px 16px;
  }

  .v-btn--floating-help-button {
    margin-bottom: 12px;
  }
}
</style>
